import { Trans, useLingui } from "@lingui/react/macro";

// Вместо «Разобрать» у не обычного матча: разбор есть только у матчей 6 на 6.
export const NoAnalysisLabel = () => {
  const { t } = useLingui();
  return (
    <span
      title={t`Analysis is only available for regular 6v6 matches`}
      className="text-sm text-subtle"
    >
      <Trans>No analysis for this mode</Trans>
    </span>
  );
};
